import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { InviteSignupProcessStepEnum } from '../../models/invite-signup-process-step.enum';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';
import { InviteSignupProcessAddressComponent } from '../invite-signup-process-address/invite-signup-process-address.component';
import { InviteSignupProcessCongratulationsComponent } from '../invite-signup-process-congratulations/invite-signup-process-congratulations.component';
import { InviteSignupProcessContractComponent } from '../invite-signup-process-contract/invite-signup-process-contract.component';
import { InviteSignupProcessDetailsComponent } from '../invite-signup-process-details/invite-signup-process-details.component';
import { InviteSignupProcessIdentityComponent } from '../invite-signup-process-identity/invite-signup-process-identity.component';
import { InviteSignupProcessPhoneComponent } from '../invite-signup-process-phone/invite-signup-process-phone.component';
import { InviteSignupProcessSmsComponent } from '../invite-signup-process-sms/invite-signup-process-sms.component';

@Component({
  selector: 'app-invite-signup-process-dialog',
  templateUrl: './invite-signup-process-dialog.component.html',
  styleUrls: ['./invite-signup-process-dialog.component.scss'],
  providers: [InviteSignupProcessService],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    InviteSignupProcessIdentityComponent,
    InviteSignupProcessDetailsComponent,
    InviteSignupProcessPhoneComponent,
    InviteSignupProcessSmsComponent,
    InviteSignupProcessAddressComponent,
    InviteSignupProcessContractComponent,
    InviteSignupProcessCongratulationsComponent,
  ],
})
export class InviteSignupProcessDialogComponent implements OnInit, OnDestroy {
  public static readonly DIALOG_CONFIG = {
    maxHeight: '790px',
    minWidth: '320px',
    maxWidth: '1024px',
  };

  public readonly inviteSignupProcessStepEnum = InviteSignupProcessStepEnum;
  private subscriptions: Array<Subscription> = [];

  constructor(
    public inviteSignupProcessService: InviteSignupProcessService,
    private dialogRef: MatDialogRef<InviteSignupProcessDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.inviteSignupProcessService.close.subscribe(() => this.close()),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public close(): void {
    this.dialogRef.close();
  }
}
